// extracted by mini-css-extract-plugin
module.exports = {"card":"messages_card__1xp6j","ref":"messages_ref__1nGFY"};